import moment from 'moment'
import customAgGridFilter from '@/constants/custom-filter-params'

const transformUtils = {
  transformTableData (value, type) {
    let lowerType = type.toLowerCase()
    if (!value && lowerType !== 'boolean') return value
    if (lowerType === 'date') return value ? moment(value).format('YYYY-MM-DD') : null
    if (['integer', 'bigint', 'double'].includes(lowerType)) return +value
    if (lowerType === 'boolean') return Boolean(value)
    return String(value).trim()
  },
  transformToPrecisionNumber (value) {
    if (typeof value === 'undefined' || value === null || value === 0) return value
    if (+Number(value).toFixed(2) !== 0) return +Number(value).toFixed(2)
    else return +Number(value).toPrecision(2)
  },
  getTypeOfValue (value) {
    if (typeof value === 'number') {
      if (Number.isInteger(value) && (value > 2147483647 || value < -2147483648)) return 'bigint'
      if (Number.isInteger(value)) return 'integer'
      return 'double'
    }
    return typeof (value)
  },
  getFilterAgGridColumnType (type) {
    let lowerType = type.toLowerCase()
    if (['integer', 'bigint', 'double'].includes(lowerType)) {
      return {
        filter: 'agNumberColumnFilter',
        filterParams: customAgGridFilter.numberFilterParams
      }
    } else if (lowerType === 'date') {
      return {
        filter: 'agDateColumnFilter',
        filterParams: customAgGridFilter.dateFilterParams
      }
    } else if (lowerType === 'boolean') {
      return {
        filter: 'agTextColumnFilter',
        filterParams: customAgGridFilter.booleanFilterParams
      }
    } else {
      return {
        filter: 'agTextColumnFilter',
        filterParams: customAgGridFilter.textFilterParams
      }
    }
  }
}
export default transformUtils



// WEBPACK FOOTER //
// ./src/utils/transformUtils.js